import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import codeTypes from '../../configurations/code-types'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormSelectField from '../FormSelectField'
import FormEntityLoadField from '../FormEntityLoadField'
import { ListingConsumer, ListingProvider } from '../../context/ListingContext'
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak'


const PackageItemCodesForm = ({ onSubmit, locale, updateParentEntity }) => {
  const classes = formStyles()

  const [codeType, setCodeType] = React.useState('GS1')
  const [itemObject, setItemObject] = React.useState({})

  const formActions = useFormik({
    initialValues: {
      codeType: 'GS1',
      itemCode: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers, updateParentEntity)
    })
  })

  React.useEffect(() => {
      // formActions.setFieldValue('itemCode', '')
      setItemObject({})
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [codeType])

  React.useEffect(() => {
      if (!!Object.keys(itemObject || {}).length) {
        onSubmit(itemObject, formActions, updateParentEntity, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [itemObject])


  return (
    <div className={classes.formWrapper}>
      <FormSelectField name={'codeType'} labelKey={'Fields.label.view.Code.codeType'} list={codeTypes}
                       classes={classes} setFilter={setCodeType} formActions={formActions} small/>

      <ListingProvider entityName={'codesSearch'} codeType={formActions?.values?.codeType || 'GS1'}
                       codeTypeChanged={codeType} disableDefaultSearch
                       listingPaging={{
                         Ps: 100,
                         Pn: 1,
                         // OnlyActive: codeType === 'GS1' ? true : '',
                         ApplyMinChoiceLevel: true,
                         CodeTypeLevelNumber: 5
                       }}>
        <ListingConsumer>
          {({ listingData, listingLoading, handleListingFilterSubmit }) => (
            <FormEntityLoadField formActions={formActions} classes={classes} name={'itemCode'}
                                 setReturnedObj={setItemObject} optionKey={'codeLookupValue'} large onlySearchBtn
                                 entityKey={'codeLookupValue'} loading={listingLoading} list={listingData}
                                 searchable={'CodeLookupValue'} loadEntities={handleListingFilterSubmit}
                                 labelKey={'Fields.label.view.Code.itemCode'} codeSearch={codeType}
                                 getOptionLabel={(option) => !!option?.codeLookupValue ? `${locale === 'ar' ? option.codeNameSecondaryLang || option.codeNamePrimaryLang : option.codeNamePrimaryLang} (${option.codeLookupValue})` || '' : ''}
                                 renderOption={(option, selected) => {
                                   return <React.Fragment>
                                     {!!option.codeLookupValue &&
                                     <div className={classes.optionWrapper}>
                                       <CenterFocusWeakIcon color={'primary'}/>
                                       <div className={classes.optionContainer}>

                                         <div className={classes.optionParent}>
                                           {(!!option.parentCodeNamePrimaryLang ||
                                             (locale === 'ar' && !!option.parentCodeNameSecondaryLang)) ?
                                             (locale === 'ar' ? option.parentCodeNameSecondaryLang || option.parentCodeNamePrimaryLang : option.parentCodeNamePrimaryLang)
                                             : <FormattedMessage id={'codesSearch.NoParent'}/>}
                                         </div>
                                         <div className={classes.option}>
                                           {locale === 'ar' ? option.codeNameSecondaryLang || option.codeNamePrimaryLang : option.codeNamePrimaryLang}
                                           <span className={classes.optionID}>
                                                     ({option.codeLookupValue})
                                                   </span>
                                         </div>
                                       </div>
                                     </div>
                                     }
                                   </React.Fragment>
                                 }}/>
          )}
        </ListingConsumer>
      </ListingProvider>
    </div>
  )
}

export default PackageItemCodesForm
